import { render, staticRenderFns } from "./BannerSeal.vue?vue&type=template&id=5cd6f247&"
import script from "./BannerSeal.vue?vue&type=script&lang=js&"
export * from "./BannerSeal.vue?vue&type=script&lang=js&"
import style0 from "./BannerSeal.vue?vue&type=style&index=0&id=5cd6f247&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports